import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense } from 'react';
import useShopDialogStore from "../../store/shop-dialog/use-store";
var LazyBOPIS_EDD_Modal = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BOPIS_EDD_Modal'));
  });
});
var BOPIS_EDD_ModalWrapper = function BOPIS_EDD_ModalWrapper() {
  var $ = _c(4);
  var isBOPIS_EDD_ModalOpen = useShopDialogStore(_temp);
  var t0;
  if ($[0] !== isBOPIS_EDD_ModalOpen) {
    t0 = isBOPIS_EDD_ModalOpen ? /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, /*#__PURE__*/React.createElement(LazyBOPIS_EDD_Modal, null)) : null;
    $[0] = isBOPIS_EDD_ModalOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var t1;
  if ($[2] !== t0) {
    t1 = /*#__PURE__*/React.createElement(React.Fragment, null, t0);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default BOPIS_EDD_ModalWrapper;
function _temp(state) {
  return state.isModalOpen;
}